import { slugify } from "utils";

export default function getAnchor(text: string) {
  return "#" + slugify(text);
}
